import React, { useCallback } from "react";
import { connect } from "react-redux";

import { MultiPin } from "@mapmycustomers/shared/types/map";

import { hideMultiPin } from "@app/scene/map/store/mapMode/actions";
import { getMultiPin } from "@app/scene/map/store/mapMode/selectors";
import { RootState } from "@app/store/rootReducer";

import BackButton from "../BackButton";

interface Props {
  hideMultiPin: typeof hideMultiPin;
  multiPin?: MultiPin;
}

const MultiPinBackButton: React.FC<Props> = ({ hideMultiPin, multiPin }) => {
  const isMultiPinMode = !!multiPin;
  const handleHideMultipin = useCallback(() => hideMultiPin(), [hideMultiPin]);

  return isMultiPinMode ? <BackButton onClick={handleHideMultipin} /> : null;
};

const mapStateToProps = (state: RootState) => ({
  multiPin: getMultiPin(state),
});

const mapDispatchToProps = {
  hideMultiPin,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiPinBackButton);
